module.exports = __webpack_public_path__ + "static/media/ctp-logo.37253cf1.png";